import React from 'react'
import PropTypes from 'prop-types'
import ActorCard from '../entity/ActorCard'

const displayFactionBoard = (faction, actors, selectedActor, unitClickHandler) => {
    if (!actors) {
        return (
            <div className="battleStage__actors no__units">&nbsp;</div>
        )
    }
    return (
        <div className={`battleStage__actors battleStage__actors--${faction}`}>
            {actors.map((actor) => {
                const { ID } = actor
                const isSelected = selectedActor === ID
                return (
                    <ActorCard
                        key={actor.ID}
                        actor={actor}
                        isSelected={isSelected}
                        clickHandler={unitClickHandler}
                    />
                )
            })}
        </div>
    )
}

const BattleStage = (props) => {
    const { factions, selectedActor, unitClickHandler } = props
    const { good: goodGuys, bad: badGuys } = factions

    return (
        <div className="battleStage__monitor">
            {displayFactionBoard('good-guys', goodGuys, selectedActor, unitClickHandler)}
            {displayFactionBoard('bad-guys', badGuys, selectedActor, unitClickHandler)}
        </div>
    )
}

BattleStage.propTypes = {
    factions: PropTypes.object.isRequired,
    selectedActor: PropTypes.string.isRequired,
    unitClickHandler: PropTypes.func.isRequired,
}

export default BattleStage
